module.exports = __webpack_public_path__ + "img/EXTERIOR-SWIFT-BOOSTER-GREEN-1.bb0eb6db.jpg";